import {MapTypeStyle} from 'vue2-google-maps';
// style generator => https://mapstyle.withgoogle.com
const landColor: string = '#cecece';
const waterColor: string = '#fafafa';

export interface GoogleMapsMarker {
  title: string;
  position: {
    lng: number;
    lat: number
  }
  label: string
}

export interface GoogleLocationSelected {
  description: string;
  latitude: number,
  longitude: number
}

export const getGooGleMapStyle: MapTypeStyle[] = [

  {
    elementType: 'geometry',
    stylers: [
      {
        color: landColor,
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#616161',
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f5f5f5',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: landColor,
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: waterColor,
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: waterColor,
      },
    ],
  },
];
